<template>
    <group-backend-layout>
        <template #page_header>
            <div
                class="mb-8 flex flex-col justify-between border-b pb-4 sm:flex-row"
            >
                <div class="order-2 flex flex-col gap-4 sm:order-1">
                    <h1 class="text-[28px] font-semibold">Overview</h1>
                </div>
                <div
                    class="order-1 mb-4 flex items-center justify-between gap-4 sm:order-2 md:justify-end"
                >
                    <GroupDashboardInviteStudentsModal
                        v-on:level-change="levelChange"
                        :level="level"
                    />
                    <GroupBuyMembershipModal>
                        <div class="btn btn-primary">
                            <div class="flex items-center gap-2">
                                <svg
                                    width="13"
                                    height="12"
                                    viewBox="0 0 13 12"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        d="M6.5 1.04167V10.9583"
                                        stroke="white"
                                        stroke-width="1.41667"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                    />
                                    <path
                                        d="M1.54175 6H11.4584"
                                        stroke="white"
                                        stroke-width="1.41667"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                    />
                                </svg>
                                <span
                                    ><span class="hidden md:inline">Buy</span>
                                    Memberships</span
                                >
                            </div>
                        </div>
                    </GroupBuyMembershipModal>
                </div>
            </div>
        </template>

        <div class="flex flex-col gap-8">
            <div class="">
                <group-dashboard-memberships-overview />
            </div>
            <div class="">
                <group-dashboard-students-overview />
            </div>
        </div>

        <ClassroomOnboardingTour
            v-if="
                !$page.props.group.pending_students_count &&
                !$page.props.classroomOptions.length &&
                !$page.props.seenTour
            "
        />
    </group-backend-layout>
</template>

<script>
import GroupBackendLayout from "@/_Layouts/GroupBackendLayout";
import GroupDashboardMembershipsOverview from "@/Components/GroupDashboardMembershipsOverview";
import GroupDashboardStudentsOverview from "@/Components/GroupDashboardStudentsOverview";
import GroupDashboardInviteStudentsModal from "@/Components/GroupDashboardInviteStudentsModal";
import GroupBuyMembershipModal from "@/Components/GroupBuyMembershipModal";
import ClassroomOnboardingTour from "@/Components/ClassroomOnboardingTour";

export default {
    name: "GroupDashboard",
    components: {
        GroupBuyMembershipModal,
        GroupDashboardInviteStudentsModal,
        GroupDashboardStudentsOverview,
        GroupDashboardMembershipsOverview,
        GroupBackendLayout,
        ClassroomOnboardingTour,
    },
    methods: {
        levelChange(val) {
            this.level = Number(val);
        },
    },
    data() {
        return {
            level: null,
        };
    },
};
</script>
